export default __webpack_public_path__ + "static/simon-english-48-ner-zqc-hgo-unsplash-62d4e279860b4bbd2553fc668ac65ef5.png";